import { SociosSocketEvent, type SocketsListener, useSocketEventListener, withRefreshStrategy } from '@capsicum/common';
import { useNonCustodialBalance } from '@socios-blk/core';
import { useMemo } from 'react';

import { useV2FTMigrationListeners } from '../hooks/useV2FTMigrationListeners';
import { type NCWalletListenersProps } from '../models';

/**
 * This UI component is plugged into Mob/Web Provider.tsx to add listeners to NCW Wallet Web Socket events
 */
export const NCWalletListeners = ({ v2FTMigrationSnackbarComponent }: NCWalletListenersProps) => {
	const { refetch: refetchNcwBalance } = useNonCustodialBalance({ cacheBypass: true }, { enabled: false });

	const { v2FTMigrationSuccessEventHandler } = useV2FTMigrationListeners({
		refetchNcwBalance,
		snackbar: v2FTMigrationSnackbarComponent
	});

	const listeners = useMemo(
		() =>
			new Map<SociosSocketEvent, SocketsListener>([
				[SociosSocketEvent.NC_WALLET_BALANCE_UPDATED, withRefreshStrategy({ listener: refetchNcwBalance })],
				[SociosSocketEvent.NC_WALLET_MIGRATION_FINISHED, withRefreshStrategy({ listener: refetchNcwBalance })],
				[
					SociosSocketEvent.NC_WALLET_FT_MIGRATION_COMPLETED,
					withRefreshStrategy({ listener: v2FTMigrationSuccessEventHandler })
				]
			]),
		[refetchNcwBalance, v2FTMigrationSuccessEventHandler]
	);

	useSocketEventListener(listeners);

	return null;
};
